import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { ModalCloseButton } from '../modal-close-button';
import { testId } from '../../../services/testid-service';
import { noop } from '../../../default-props/noop';

import style from './modal-header.module.css';

/**
 * @deprecated Use `Modal` from `@mantine/core` + `ModalContent`/`ModalFooter` from `@shipstation/client-common` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const ModalHeader = ({ children, className = '', closeModal = noop, preventClose = false, id }) => {
  const headerClasses = classNames(style['modal-header'], className);
  return (
    <div {...testId('modal-header')} className={headerClasses}>
      <div className={style['header-content']} id={id}>
        {children}
      </div>
      {!preventClose && <ModalCloseButton className={style['close-button']} closeModal={closeModal} />}
    </div>
  );
};

ModalHeader.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  closeModal: PropTypes.func,
  preventClose: PropTypes.bool,
  id: PropTypes.string,
};
